import { Component } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css']
})

export class LoaderComponent {

    showLoading: boolean;

    constructor(private loaderService: LoaderService) {
        loaderService.showLoaderEvent.subscribe(value => this.showLoader(value));
    }

    showLoader(value: boolean) {
        this.showLoading = value;
        // var imgLoader = document.getElementById("imgLoader") as HTMLImageElement;
        // imgLoader.src = './assets/images/AnimationLoading.gif';
        // if (value == true) {
        //     imgLoader.style.visibility = 'visible';
        // }
        // else {
        //     imgLoader.style.visibility = 'hidden';
        // }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/loader/loader.component.ts